import { useQuery } from '@tanstack/react-query'
import { adminApi } from '../adminApi.js'
import type {
  AuditLogResponse,
  ListTenantsResponse,
  PlanTiersResponse,
  TenantDetailResponse,
} from '../types.js'

export const tenantsListKey = ['admin', 'tenants', 'list'] as const
export const tenantDetailKey = (id: string) =>
  ['admin', 'tenants', 'detail', id] as const
export const planTiersKey = ['admin', 'plan-tiers'] as const
export const tenantAuditKey = (id: string) =>
  ['admin', 'audit-log', 'tenant', id] as const

/** Full tenant list — filtering/search is client-side per the 3b brief. */
export function useTenantList() {
  return useQuery({
    queryKey: tenantsListKey,
    queryFn: () => adminApi.get<ListTenantsResponse>('/tenants'),
  })
}

export function useTenantDetail(id: string) {
  return useQuery({
    queryKey: tenantDetailKey(id),
    queryFn: () => adminApi.get<TenantDetailResponse>(`/tenants/${id}`),
  })
}

export function usePlanTiers() {
  return useQuery({
    queryKey: planTiersKey,
    staleTime: 5 * 60_000,
    queryFn: () => adminApi.get<PlanTiersResponse>('/plan-tiers'),
  })
}

/** Last-N audit entries scoped to one tenant. */
export function useTenantAuditLog(id: string, limit = 10) {
  return useQuery({
    queryKey: tenantAuditKey(id),
    queryFn: () =>
      adminApi.get<AuditLogResponse>(
        `/audit-log?tenant_id=${encodeURIComponent(id)}&limit=${limit}`,
      ),
  })
}
